// Cálculos puros do Benchmarking (classificação relativa/absoluta, formatação
// de variação e montagem das linhas da tabela), extraídos de index.jsx para
// serem testados sem montar o componente/redux.
import { C, ESCALA } from "../dashboard/_shared";

const TIPO_MAP = { cx: "JCX", nps: "NPS", ces: "CES", csat: "CSAT" };

const DESTAQUES = new Set([
  "Jornada CX Geral",
  "NPS Geral",
  "CES Geral",
  "CSAT Geral",
]);

// Ordem fixa dos indicadores "Geral" no topo da tabela; os demais ficam em
// ordem alfabética logo abaixo.
const ORDEM = ["Jornada CX Geral", "NPS Geral", "CES Geral", "CSAT Geral"];

// Classificação relativa: a diferença entre o valor do cliente e a média do
// sistema Unimed.
export function classifyPos(vc, med) {
  const d = vc - med;
  if (d >= 10) return { label: "🏆 Top sistema", color: C.green, bg: C.greenBg };
  if (d >= 3) return { label: "↑ Acima da média", color: C.blue, bg: C.blueBg };
  if (d > -3) return { label: "→ Na média", color: C.orange, bg: C.orangeBg };
  return { label: "↓ Abaixo da média", color: C.red, bg: C.redBg };
}

// Classificação absoluta: usa a escala de NPS (-100 a 100) pro tipo NPS, e a
// ESCALA padrão (CES/CSAT/JCX, 0 a 100) pros demais.
export function classifyAbs(tipo, val) {
  if (tipo === "NPS") {
    if (val >= 75) return { label: "✦ Excelência", color: "#059669", bg: "#ECFDF5" };
    if (val >= 50) return { label: "✓ Qualidade", color: "#16a34a", bg: "#F0FDF4" };
    if (val >= 0) return { label: "→ Aperfeiçoamento", color: "#d97706", bg: "#FFFBEB" };
    return { label: "✗ Crítico", color: "#991b1b", bg: "#FFF1F2" };
  }
  const e = ESCALA.find((x) => val >= x.min) || ESCALA[ESCALA.length - 1];
  return { label: e.label, color: e.color, bg: e.bg };
}

// Formata a variação do cliente vs. uma referência (sistema Unimed ou
// concorrência nacional) — "pts" pra NPS, "pp" pros demais indicadores.
export function fmtVar(tipo, vc, ref) {
  const d = vc - ref;
  const sign = d > 0 ? "+" : d < 0 ? "−" : "";
  const abs = Math.abs(d);
  const unit = tipo === "NPS" ? "pts" : "pp";
  const color = d >= 3 ? C.green : d <= -3 ? C.red : C.orange;
  return { text: `${sign}${abs} ${unit}`, color };
}

// Converte os dados crus do benchmarking em linhas prontas pra tabela,
// ordenadas com os indicadores "Geral" primeiro (ordem fixa) e o resto em
// ordem alfabética.
export function transformarBenchmarks(data) {
  return (data || [])
    .map((item) => ({
      k: item.name,
      tipo: TIPO_MAP[item.category],
      vc: item.value,
      med: item.unimed_system_avg,
      conc: item.national_competition,
      destaque: DESTAQUES.has(item.name),
    }))
    .sort((a, b) => {
      const ia = ORDEM.indexOf(a.k);
      const ib = ORDEM.indexOf(b.k);
      if (ia !== -1 && ib !== -1) return ia - ib;
      if (ia !== -1) return -1;
      if (ib !== -1) return 1;
      return a.k.localeCompare(b.k);
    });
}
